module.exports = __webpack_public_path__ + "static/img/rotate05.18a3a37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate05.png
// module id = RVyl
// module chunks = 1